import ActionMenu, {
  type ActionMenuItemProps,
} from "@/v2-backoffice-client/components/actionMenu"
import { useTenantUserRemoveMutation } from "@/v2-backoffice-client/tenant/user/remove/tenant.user.remove.mutation"

export type TenantUserRemoveMenuItemProps = Omit<
  ActionMenuItemProps,
  "onClick"
> & {
  tenantId: number
  userId: number
  userName?: string
  onCompleted?(): void
}

function TenantUserRemoveMenuItem(props: TenantUserRemoveMenuItemProps) {
  const { tenantId, userId, userName, onCompleted, ...menuItemProps } = props

  const [removeTenantUser, { loading, error }] = useTenantUserRemoveMutation({
    onCompleted,
  })

  return (
    <ActionMenu.ConfirmItem
      iconSrc="trash"
      variant="destructive"
      isLoading={loading}
      error={error}
      errorTitle="Failed to remove user from team"
      confirmTitle="Remove from Team"
      confirmDescription={
        userName
          ? `Are you sure you want to remove ${userName} from this team?`
          : "Are you sure you want to remove this user from the team?"
      }
      confirmText="Remove"
      confirmVariant="destructive"
      onConfirm={async () => {
        await removeTenantUser({ variables: { tenantId, userId } })
      }}
      {...menuItemProps}
    >
      Remove from Team
    </ActionMenu.ConfirmItem>
  )
}

export default TenantUserRemoveMenuItem
